<template>
  <main class="main inside-page form-page register-page">
    <div class="section register-section">
      <div class="left">
        <div class="left-wrapper">
          <router-link to="/" class="logo">
            <img class="img" src="../images/logo.svg" />
            <div class="title tiny">Elystr</div>
          </router-link>
          <div class="title">
            {{ $t("Create Your Account!") }}
          </div>
          <ValidationObserver
            ref="form"
            v-slot="{ handleSubmit }"
            slim
            class="form"
          >
            <form @submit.prevent="handleSubmit(submit)">
              <ValidationProvider
                mode="passive"
                rules="required"
                v-slot="{ errors }"
                vid="name"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Name") }}:</b>
                  </div>
                  <input
                    required
                    name="name"
                    v-model="name"
                    type="text"
                    :placeholder="$t('Enter you name')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <ValidationProvider
                slim
                rules="required"
                name="Surname"
                vid="surname"
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Surname") }}:</b>
                  </div>
                  <input
                    required
                    name="surname"
                    v-model="surname"
                    :placeholder="$t('Enter you surname')"
                    type="text"
                  />
                </label>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                rules="required|email"
                v-slot="{ errors }"
                vid="email"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("E-mail") }}:</b>
                  </div>
                  <input
                    required
                    name="email"
                    v-model="email"
                    type="text"
                    :placeholder="$t('Enter you e-mail')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                rules="required"
                v-slot="{ errors }"
                vid="phone"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Phone") }}:</b>
                  </div>
                  <input
                    required
                    name="phone"
                    v-model="phone"
                    type="text"
                    :placeholder="$t('Enter you phone')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                rules="required|min:5"
                vid="password"
                v-slot="{ errors }"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Password") }}:</b>
                  </div>
                  <input
                    required
                    name="password"
                    v-model="password"
                    type="password"
                    :placeholder="$t('Enter you рassword')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>

              <ValidationProvider
                mode="passive"
                rules="required|confirmed:password"
                :customMessages="{ confirmed: 'Password does not match' }"
                v-slot="{ errors }"
                vid="password_confirmation"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Confirm password") }}:</b>
                  </div>
                  <input
                    required
                    name="password_confirmation"
                    v-model="password_confirmation"
                    type="password"
                    :placeholder="$t('Enter you рassword')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>

              <div v-if="error" class="general-error">
                {{ error }}
              </div>

              <ValidationProvider
                mode="passive"
                slim
                :rules="{ required: { allowFalse: false } }"
                vid="agree"
                v-slot="{ errors }"
              >
                <div class="agree">
                  <checkbox class="desc" v-model="agree">
                    <span>
                      {{ $t("I agree to the") }}
                      <router-link
                        :to="
                          generatePathWithParams(
                            staticPages.find((it) => it.is_terms).title,
                            staticPages.find((it) => it.is_terms).id
                          )
                        "
                        class="link"
                      >
                        <b>{{ $t("Terms&Conditions") }}</b>
                      </router-link>

                      {{ $t("and") }}
                      <router-link
                        :to="
                          generatePathWithParams(
                            staticPages.find((it) => it.is_privacy).title,
                            staticPages.find((it) => it.is_privacy).id
                          )
                        "
                        class="link"
                      >
                        <b>{{ $t("Privacy Policy") }}</b>
                      </router-link>
                    </span>
                  </checkbox>
                  <div v-if="errors.length" class="error">
                    {{ $t("Please agree with rules") }}
                  </div>
                </div>
              </ValidationProvider>
              <div class="button-container">
                <button type="submit" class="button colored">
                  {{ $t("Continue") }}
                </button>
              </div>
              <div class="center-link-container">
                <div class="desc">{{ $t("Have an account?") }}</div>
                <router-link to="/login" class="desc link">
                  <b>{{ $t("Sign In") }}</b>
                </router-link>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div class="right"></div>
    </div>
  </main>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "@/axios";
import router from "@/router";
import { mapActions } from "vuex";
import Checkbox from "@/components/Checkbox.vue";
import { mapGetters } from "vuex";

export default {
  name: "Register",
  props: [],
  components: {
    Checkbox,
    ValidationProvider,
    ValidationObserver,
  },
  data: function () {
    return {
      name: "",
      surname: "",
      email: "",
      phone: "",
      password: "",
      password_confirmation: "",
      error: "",
      agree: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("app", ["staticPages"]),
  },
  methods: {
    convertTitle(title) {
      if (typeof title === "string") {
        return title.replace(/ /g, "_").toLowerCase();
      }
      return title;
    },
    generatePathWithParams(title, id) {
      const convertedTitle = this.convertTitle(title);
      return {
        name: "TextPage",
        params: { title: convertedTitle, id: id },
      };
    },
    submit() {
      const self = this;

      axios
        .post("register", {
          name: this.name,
          // surname: this.surname,
          password: this.password,
          password_confirmation: this.password_confirmation,
          email: this.email,
          phone: this.phone,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.getProfile();
            router.push("/");
          } else if (data.status === "ERROR") {
            self.error = data.message;
          }
        })
        .catch(({ response }) => {
          if (response.status === 400) {
            console.log(response);

            if (response.data.message) {
              self.error = response.data.message;
            } else if (response.data.errors) {
              this.$refs.form.setErrors(response.data.errors);
            }
          }
        });
    },
    ...mapActions("user", ["getProfile"]),
  },
};
</script>
